import { endpoint } from "../../common/constant"
import { dropdownMapping } from "../../common/utils/methods/commonMethods/utilityMethod"

export const getDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(endpoint.region.getAllActive, 'regionDispValue', 'id'),
    dropdownMapping(endpoint.businessArea.getAllActiveV2, 'businessAreaDispValue', 'id'),
    dropdownMapping(endpoint.academic_career.getAllActive,"academicCareerDispValue","academicCareerDispValue"),
  ])

  return {
    region: p[0],
    businessArea: p[1],
    academicCareer : p[2]
  }
}